import { render, staticRenderFns } from "./bidTermination.vue?vue&type=template&id=46c6a76f&scoped=true"
import script from "./bidTermination.vue?vue&type=script&lang=js"
export * from "./bidTermination.vue?vue&type=script&lang=js"
import style0 from "./bidTermination.vue?vue&type=style&index=0&id=46c6a76f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c6a76f",
  null
  
)

export default component.exports